import React, {useContext} from "react";
import "./StartupProjects.scss";
import {bigProjects, myProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  return (
    <div className="main" id="projects">
      <Fade bottom duration={1000} distance="20px">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null} 
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <>
                              <div>
                                <div className="software-skills-main-div">
                                  <ul className="dev-icons2">
                                    {project.icons.map((el, i) => {
                                      return (
                                        <li
                                          key={i}
                                          className="software-skill-inline"
                                          name={el.skillName}
                                        >
                                          <i
                                            className="iconify"
                                            data-icon={el.dataIcon}
                                          ></i>
                                          <p>{el.skillName}</p>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                              </div>
                              <span
                                key={i}
                                className={
                                  isDark
                                    ? "dark-mode project-tag"
                                    : "project-tag"
                                }
                                onClick={() => openUrlInNewTab(link.url)}
                              >
                                {link.name}
                              </span>
                            </>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Fade>
      {/* My Projects */}
      <Fade bottom duration={1000} distance="20px">
        <div style={{marginTop: "5%"}}>
          <h1 className="skills-heading">{myProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {myProjects.subtitle}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/siddhesh-06"
            >
              Click here :)
            </a>
          </p>

          <div className="projects-container">
            {myProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <>
                              <div>
                                <div className="software-skills-main-div">
                                  <ul className="dev-icons2">
                                    {project.icons.map((el, i) => {
                                      return (
                                        <li
                                          key={i}
                                          className="software-skill-inline"
                                          name={el.skillName}
                                        >
                                          <i
                                            className="iconify"
                                            data-icon={el.dataIcon}
                                          ></i>
                                          <p>{el.skillName}</p>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                              </div>
                              <span
                                key={i}
                                className={
                                  isDark
                                    ? "dark-mode project-tag"
                                    : "project-tag"
                                }
                                onClick={() => openUrlInNewTab(link.url)}
                              >
                                {link.name}
                              </span>
                            </>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Fade>
    </div>
  );
}
